import React from 'react';

export interface AvatarProps {
    src?: string;
    fallback?: string;
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    className?: string;
}

const sizes = {
    xs: 'w-6 h-6 text-xs',
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base',
    xl: 'w-16 h-16 text-lg',
};

const Avatar: React.FC<AvatarProps> = ({ src, fallback, size = 'md', className = '' }) => {
    const [imgError, setImgError] = React.useState(false);
    const base = `inline-flex items-center justify-center rounded-full font-semibold select-none shrink-0 ${sizes[size]} ${className}`;

    if (src && !imgError) {
        return (
            <img
                src={src}
                alt={fallback ?? ''}
                onError={() => setImgError(true)}
                className={`${base} object-cover`}
            />
        );
    }

    const letters = fallback
        ? fallback.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase()
        : '?';

    return (
        <span className={`${base} bg-slate-100 text-slate-600 border border-slate-200`}>
            {letters}
        </span>
    );
};

Avatar.displayName = 'Avatar';
export default Avatar;
